import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserDepartment = createAsyncThunk(
    '/add/addUserDepartment ',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-department`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserDepartment = response.data;
            // console.log(addUserDepartment, '@@@')

            if (addUserDepartment.success === true) {
                toast.success(addUserDepartment?.message);
                return addUserDepartment;
            } else {
                // console.log(addUserDepartment.message, "&&&&")
                throw new Error(addUserDepartment.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserDepartmentSlice = createSlice({
    name: "addUserDepartment ",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserDepartment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserDepartment.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserDepartment.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserDepartmentSlice.reducer;